import { TRANSPORT_PAGES } from "@/router/pageNames";

export const defaultColumnsOrder = () => {

  return [
    { key: "shipper" },
    { key: "phase" },
    { key: "punctuality" },
    { key: "actionRequired" },
    { key: "scheduledDate" },
    { key: "nextScheduled" },
    { key: "cancelledAt" },
    { key: "eta" },
    { key: "nextEta" },
    { key: "ata" },
    { key: "from" },
    { key: "nextAddress" },
    { key: "to" },
    { key: "carrier" },
    { key: "reference" },
    { key: "waypoints" },
    { key: "trackingId" },
    { key: "gpsSignalIndicator" },
    { key: "actions" },
  ];
};

export function defaultColumnsVisibility({ pageName }) {

  switch (pageName) {
    case TRANSPORT_PAGES.ACTION_REQUIRED_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: false },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.TRACKING_ID_MISSING_TRANSPORTS:
    case TRANSPORT_PAGES.GPS_MISSING_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: false },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.GPS_LOW_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: false },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: false },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.GPS_LOST_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: false },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: false },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: false },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.WAYPOINT_CONFIRMATION_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: false },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.PLANNED_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "from", enabled: false },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.INCOMING_TRANSPORTS:
    case TRANSPORT_PAGES.ONGOING_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: false },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.PRESUMABLY_INCOMING_TRANSPORTS:
    case TRANSPORT_PAGES.PRESUMABLY_ONGOING_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "from", enabled: false },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.ONGOING_ARRIVED_TRANSPORTS:
    case TRANSPORT_PAGES.NO_DEPARTURE_FROM_DESTINATION_TRANSPORTS:
    case TRANSPORT_PAGES.DEPARTED_TRANSPORTS:
    case TRANSPORT_PAGES.COMPLETED_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: false },
        { key: "scheduledDate", enabled: true, sortable: true },
        { key: "ata", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "actions", enabled: false },
      ];

    case TRANSPORT_PAGES.AREA_ARRIVED_TRANSPORTS:
    case TRANSPORT_PAGES.MANUALLY_COMPLETED_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: false },
        { key: "scheduledDate", enabled: true, sortable: true },
        { key: "ata", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.OVERDUE_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "actionRequired", enabled: false },
        { key: "scheduledDate", enabled: true, sortable: true },
        { key: "ata", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.CANCELLED_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },    
        { key: "scheduledDate", enabled: true, sortable: true },
        { key: "cancelledAt", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.SEARCH_RESULTS:
    case TRANSPORT_PAGES.WATCHLIST:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "cancelledAt", enabled: true, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "ata", enabled: true, sortable: true },
        { key: "carrier", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "reference", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];

    case TRANSPORT_PAGES.LOCATION_ARRIVAL_TRANSPORTS:
      return [
        { key: "shipper", enabled: true },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: false },
        { key: "scheduledDate", enabled: true, sortable: false },
        { key: "eta", enabled: true, sortable: false },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
      ];

    default:
      return [
        { key: "shipper", enabled: true },
        { key: "phase", enabled: false },
        { key: "punctuality", enabled: true },
        { key: "actionRequired", enabled: true },
        { key: "scheduledDate", enabled: false, sortable: true },
        { key: "nextScheduled", enabled: true, sortable: true },
        { key: "eta", enabled: false, sortable: true },
        { key: "nextEta", enabled: true, sortable: true },
        { key: "ata", enabled: false, sortable: true },
        { key: "from", enabled: true },
        { key: "nextAddress", enabled: true },
        { key: "to", enabled: true },
        { key: "carrier", enabled: true },
        { key: "reference", enabled: true },
        { key: "waypoints", enabled: true },
        { key: "trackingId", enabled: true },
        { key: "gpsSignalIndicator", enabled: true },
        { key: "actions", enabled: true },
      ];
  }
}
